import React from 'react';
import { Button, Input } from 'antd';
import Image from 'next/image';
import './index.less';

const TextboxWithAttachment = ({
  inputPlaceholderText,
  buttonConfig,
}: {
  inputPlaceholderText: string;
  requireProjectBrief: boolean;
  buttonConfig?: {
    buttonText: string;
    onClick: () => void;
  };
}) => {
  const customButton = (
    <Button className="btn" onClick={buttonConfig?.onClick ?? (() => null)}>
      <span>{buttonConfig?.buttonText ?? ''}</span>
    </Button>
  );

  const renderShareIcon = (
    <Image className="upload-file-icon" src="/images/sourcing/share-black.svg" width={16} height={16} alt="share" />
  );

  const fileIcon = (
    <div className="upload-icon" onClick={buttonConfig?.onClick}>
      {renderShareIcon}
      <span className="text">Attach designs</span>
    </div>
  );

  const fileUploadContainer = (
    <div className="file-upload-container">
      {fileIcon}
      {buttonConfig && customButton}
    </div>
  );

  return (
    <div className="textbox-with-attachment">
      <Input placeholder={inputPlaceholderText} onClick={buttonConfig?.onClick} /> {fileUploadContainer}
    </div>
  );
};

export default TextboxWithAttachment;
